var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26786",
    "data-name": "Group 26786",
    transform: "translate(-1230 -371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26785",
    "data-name": "Group 26785",
    transform: "translate(66 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25383",
    "data-name": "Group 25383",
    transform: "translate(1164 383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4677",
    "data-name": "Rectangle 4677",
    fill: "none",
    stroke: "#0d2768",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "_Input_text",
    "data-name": "\\u270F\\uFE0F Input text",
    d: "M.5-9.593a3.034,3.034,0,0,1,.325-.249,2.333,2.333,0,0,1,.382-.205,2.376,2.376,0,0,1,.445-.137,2.537,2.537,0,0,1,.519-.05,2.164,2.164,0,0,1,.692.1,1.555,1.555,0,0,1,.535.3,1.333,1.333,0,0,1,.345.469,1.5,1.5,0,0,1,.122.615,1.554,1.554,0,0,1-.1.574,1.616,1.616,0,0,1-.24.421,1.817,1.817,0,0,1-.316.31l-.325.247a2.552,2.552,0,0,0-.264.227.448.448,0,0,0-.133.251l-.1.637H1.649l-.074-.711a.578.578,0,0,1,.059-.36,1.1,1.1,0,0,1,.227-.284,2.991,2.991,0,0,1,.316-.249A2.868,2.868,0,0,0,2.5-7.945a1.374,1.374,0,0,0,.255-.319.825.825,0,0,0,.1-.421A.65.65,0,0,0,2.8-8.966.636.636,0,0,0,2.64-9.18a.734.734,0,0,0-.251-.137,1.008,1.008,0,0,0-.316-.048,1.41,1.41,0,0,0-.421.055,1.553,1.553,0,0,0-.292.122q-.12.068-.2.122a.279.279,0,0,1-.148.055.238.238,0,0,1-.227-.131Zm.825,5.145a.671.671,0,0,1,.05-.257.632.632,0,0,1,.137-.209.66.66,0,0,1,.209-.14.658.658,0,0,1,.262-.052.642.642,0,0,1,.26.052.7.7,0,0,1,.209.14.642.642,0,0,1,.142.209.647.647,0,0,1,.052.257.642.642,0,0,1-.052.26.648.648,0,0,1-.142.207.663.663,0,0,1-.209.137.666.666,0,0,1-.26.05.682.682,0,0,1-.262-.05.632.632,0,0,1-.209-.137.637.637,0,0,1-.137-.207A.666.666,0,0,1,1.322-4.448Z",
    transform: "translate(1234 383.892)",
    fill: "#0b2055"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoQuestion);
export default __webpack_public_path__ + "static/media/info-question.fce681f772993e58c4b41a9d0554023e.svg";
export { ForwardRef as ReactComponent };